export * from "/__w/wiggot-web/wiggot-web/packages/web-components/components/nav-bar-home/nav-bar-home/NavbarHome.tsx"